import type { TreeStateModel } from './tree.model';

/**
 *
 * @returns
 */
export function getDefaults(): TreeStateModel {
  return {
    flatTree: [],
    multi_selection: {},
    isLoading: false,
    hasError: false,
  };
}
